export default __webpack_public_path__ + "static/media/about-sec-img.27acfc1a.png";